import { TemplateRef } from '@angular/core';
import { ApiService } from '../../../services/api.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { ProductListDetailComponent } from '../product-list-detail/product-list-detail.component';
import { finalize } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
var ProductListComponent = (function () {
    function ProductListComponent(apiService, translate, authService, modalService) {
        this.apiService = apiService;
        this.translate = translate;
        this.authService = authService;
        this.modalService = modalService;
        this.itemsPerPage = 40;
        this.modal = null;
        this.modalData = null;
        this.searchProductID = '';
        this.searchProductName = '';
        this.searchProductDept = '';
        this.department_choices = [];
        this.groups = [];
        this.currentPage = 1;
        this.loading = false;
        this.list = [];
        this.departmentChoices = [];
        this.productDetails = [];
    }
    ProductListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.subs = this.translate.onLangChange.subscribe(function () {
            _this.loadDepartment();
        });
        this.loadDepartment();
        this.loadData();
    };
    ProductListComponent.prototype.reload = function () {
        this.pageChanged();
    };
    ProductListComponent.prototype.pageChanged = function () {
        this.loadData();
    };
    ProductListComponent.prototype.optionChanged = function () {
        this.search();
    };
    ProductListComponent.prototype.openModal = function (data, index) {
        this.detailModal.open(this, data);
    };
    ProductListComponent.prototype.search = function () {
        this.currentPage = 1;
        this.loadData();
    };
    ProductListComponent.prototype.loadData = function () {
        var _this = this;
        this.loading = true;
        var params = {
            page: this.currentPage,
            items_per_page: this.itemsPerPage,
            product_id: this.searchProductID,
            name: this.searchProductName,
            department_name: this.searchProductDept,
        };
        this.apiService.getProducts(params)
            .pipe(finalize(function () {
            _this.loading = false;
        }))
            .subscribe(function (res) {
            _this.productDetails = res.results;
            _this.totalItems = res.count;
        });
    };
    ProductListComponent.prototype.loadDepartment = function () {
        var _this = this;
        this.apiService.getDepartments().subscribe(function (response) {
            _this.department_choices = response;
            _this.departmentChoices = response.map(function (item) {
                return {
                    value: item.id,
                    label: _this.translate.currentLang === 'en'
                        ? item.name_en
                        : item.name_th
                };
            });
        });
    };
    ProductListComponent.prototype.confirmDelete = function (index) {
        this.modalData = this.productDetails[index];
        this.modal = this.modalService.open(this.deleteConfirmationModal, { backdrop: 'static', centered: true });
    };
    ProductListComponent.prototype.confirmedDelete = function (productId) {
        var _this = this;
        this.apiService.deleteProduct(productId).subscribe(function () {
            _this.loadData();
            _this.sniff('DELETE_PRODUCT', _this.modalData.product_id + ';' + _this.modalData.name_en);
            _this.revertBack();
        });
    };
    ProductListComponent.prototype.clearSearch = function () {
        this.searchProductID = '';
        this.searchProductName = '';
        this.searchProductDept = '';
        this.loadData();
    };
    ProductListComponent.prototype.revertBack = function () {
        this.modal.close();
        this.modal = null;
        this.modalData = null;
    };
    ProductListComponent.prototype.sniff = function (action, target) {
        var data = {
            action: action,
            address: 'MANAGE_PRODUCT',
            target: target
        };
        this.apiService.sniff(data).subscribe(function (res) {
        });
    };
    ProductListComponent.prototype.ngOnDestroy = function () {
        this.subs.unsubscribe();
    };
    Object.defineProperty(ProductListComponent.prototype, "isAdmin", {
        get: function () {
            return this.authService.isAdmin();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductListComponent.prototype, "isAccountant", {
        get: function () {
            return this.authService.isAccountant();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductListComponent.prototype, "isAccountantAdmin", {
        get: function () {
            return this.authService.isAccountantAdmin();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ProductListComponent.prototype, "lang", {
        get: function () {
            return this.translate.currentLang;
        },
        enumerable: true,
        configurable: true
    });
    return ProductListComponent;
}());
export { ProductListComponent };



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product-list/product-list.component.ts.pre-build-optimizer.js